/* eslint-disable*/
import './assets/styles/app.scss';
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
// import '@fortawesome/fontawesome-free/js/regular';
// import '@fortawesome/fontawesome-free/js/brands';
import 'popper.js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/popover';


// import 'gene-event-handler/app/scripts/validatr';
import 'gene-event-handler/app/scripts/jquery.gene';

// window.mainUrl = 'http://music.sense-info.co/';
// window.apiUrl = window.mainUrl + '';

var gee = gee || $.fn.gene;
gee.debug = true;
// import './extend';
import './assets/scripts/app';
import './assets/scripts/arena';
import './assets/scripts/cookie';


// $.views.settings.delimiters('<%', '%>');
// $.views.helpers(app.formatHelper);
gee.hook('removeMe', function () {
	removeMe();
});


$(document).ready(function () {
	/* eslint-disable-next-line*/
	app.init(['arena']);
	$('[data-toggle=popover]').popover({
		html: true,
		trigger: 'focus'
	});

});
